module.exports = {
  default: ['gmail.com', 'yahoo.com', 'outlook.com'],
  AT: ['gmail.com', 'hotmail.com', 'bigpond.com'],
  BR: ['gmail.com', 'yahoo.com', 'hotmail.com'],
  CA: ['gmail.com', 'hotmail.com', 'yahoo.com'],
  DK: ['gmail.com', 'hotmail.com', 'live.dk'],
  FI: ['gmail.com', 'yahoo.fi', 'inbox.fi'],
  FR: ['gmail.com', 'hotmail.fr', 'orange.fr'],
  DE: ['gmail.com', 'gmx.de', 'web.de'],
  IN: ['gmail.com', 'yahoo.com', 'hotmail.com'],
  IT: ['gmail.com', 'libero.it', 'hotmail.it'],
  JP: ['gmail.com', 'yahoo.co.jp', 'docomo.ne.jp'],
  LV: ['gmail.com', 'inbox.lv', 'apollo.lv'],
  LT: ['gmail.com', 'inbox.lt', 'yahoo.com'],
  NL: ['gmail.com', 'hotmail.com', 'live.nl'],
  NZ: ['gmail.com', 'hotmail.com', 'xtran.co.nz'],
  PL: ['gmail.com', 'wp.pl', 'o2.pl'],
  RU: ['mail.ru', 'gmail.com', 'yandex.ru'],
  ES: ['gmail.com', 'hotmail.com', 'yahoo.es'],
  SE: ['gmail.com', 'hotmail.com', 'live.se'],
  GB: ['gmail.com', 'yahoo.co.uk', 'hotmail.com'],
  US: ['gmail.com', 'yahoo.com', 'hotmail.com'],
  UY: ['gmail.com', 'yahoo.com', 'outlook.com']
}



// WEBPACK FOOTER //
// ./src/data/emailProviders.js